import { connect } from "react-redux";
import { getDetailCustomer, lichSuGiaoDich } from "actions/Customer";
import ChiTietKhachHang from "components/CommonComponent/ChiTietKhachHang";

const mapStateToProps = (state) => ({
  customer: state.customer,
});

const mapDispatchToProps = (dispatch) => ({
  getDetailCustomer: (dataSearch) => dispatch(getDetailCustomer(dataSearch)),
  lichSuGiaoDich: (dataSearch) => dispatch(lichSuGiaoDich(dataSearch)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChiTietKhachHang);
